import { render, staticRenderFns } from "./btc-video-card-col.vue?vue&type=template&id=d3d9bb2e&scoped=true&"
import script from "./btc-video-card-col.vue?vue&type=script&lang=js&"
export * from "./btc-video-card-col.vue?vue&type=script&lang=js&"
import style0 from "./btc-video-card-col.vue?vue&type=style&index=0&id=d3d9bb2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d9bb2e",
  null
  
)

export default component.exports